module.exports = __webpack_public_path__ + "img/cleaf5.99cec438.jpg";